/**
 * What the console needs to know about a site before it can work.
 *
 * Today there is one such thing, and it is the quietest failure in the
 * product: a site with no allowed domains fails closed in the widget
 * (`origins_unconfigured`), so the customer embeds the snippet, reloads their
 * page, sees nothing at all, and has no way to find out why. The server is
 * right to refuse — an empty list must never mean "anyone" — so the console
 * is the side that has to speak up.
 */

export function needsOrigins(site: { allowedOrigins: string[] }): boolean {
  return site.allowedOrigins.length === 0;
}

/** The ids of the sites in a list that are not going to load anywhere yet. */
export function sitesNeedingOrigins(sites: Array<{ id: number; allowedOrigins: string[] }>): number[] {
  return sites.filter(needsOrigins).map((s) => s.id);
}
